import React, {Component} from 'react';
import {Select, message} from 'antd';
import HttpTool from "../../../../tool/HttpTool";
import APILXD from '../../../../http/APILXD';

/**
 * 选择服务器套餐
 */
class Index extends Component {
  constructor(props) {
    super(props);

    this.state = {
      comboSel: undefined,
      comboList: []
    }
  }

  date = (option) => {
    this.props.verification(this.props.data, option)
  }

  componentDidMount() {
    this.getComboList()
  }

  getComboList = () => {
    HttpTool.post(APILXD.pricePackageGetList,(code,msg,json)=>{
      let defaultValue = undefined;
      let obj = null;
      if(this.props.data?.option?.defaultValue){
        obj = json.find(item => item._id === this.props.data?.option?.defaultValue);
        console.log("item",obj)
        if(obj){
          defaultValue = obj._id;
        }else{
          defaultValue = undefined;
          message.warning("原套餐已不可用，请重新选择")
        }
      }
      this.setState({
        comboList: json,
        comboSel: defaultValue
      },()=>{
        this.date(obj?{
          label: `${obj.name}（算力: ${obj.countLimit}次，agent: ${obj.agentCountLimit}次）`,
          value: obj._id,
          countLimit: obj.countLimit,
          agentCountLimit: obj.agentCountLimit,
        }:undefined)
      })
    },(code,msg)=>{
      message.error(msg);
    },{
      page: 1,
      pageSize: 100,
      enable: true,
      payType: 'package_pay',
      productType: 'compute_power'
    })
  }

  render() {
    return (
      <div>
        <Select
          {...this.props.option}
          options={this.state.comboList?.map((obj)=>{
            return {
              label: `${obj.name}（算力: ${obj.countLimit}次，agent: ${obj.agentCountLimit}次）`,
              value: obj._id,
              countLimit: obj.countLimit,
              agentCountLimit: obj.agentCountLimit,
            }
          })}
          defaultValue={undefined}
          value={this.state.comboSel}
          onChange={(item, option) =>{
            console.log("option", option)
            this.setState({
              comboSel: option.value
            },()=>{
              this.date(option)
            })
          }}
        />
      </div>
    )
  }
}

export default  Index;